import Vue from 'vue'
import Vuex from 'vuex'
import quiz from '@/store/quiz'
import createWebSocket from './connection'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    quiz
  },
  plugins: [createWebSocket()]
})
